var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"40323f65f2f60e0c086ad78f12c9062d15fd741a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["squeeze-prd-vercel@squeeze-o2"]={id:"40323f65f2f60e0c086ad78f12c9062d15fd741a"};
      